import { i18n } from 'src/utils/localeUtil';
import { CREATIVE_TYPE } from 'src/const/state/creative';

// 应用下载广告类型
export const appTypeReg = {
  iosReg: /^https?:\/\/(itunes|apps).apple.com\/.+\/id(\d+)(\?.+)?/,
  androidReg: /^https?:\/\/play.google.com\/store\/apps\/details\?((.+&)?id=([A-Za-z0-9.\-_]+))(&.+)?/,
};

export const adAppType = {
  ANDROID: 201,
  IOS: 202,
  NO_LIMIT: 0,
};
export const OptStatus = {
  ON: 0, // 打开
  OFF: 1, // 关闭
  FROZEN: 2, // 冻结
};

export const pixelAndPixelEventStatus = {
  NotSupport: 0,
  NoRecentActivity: 1,
  Active: 2,
};
export const pixelAssetRelationStatus = {
  EM: 0,
  SHARE_WITH_OTHERS: 1,
  SHARED_BY_OTHERS: 2,
  UNBUNDLING: 3,
};

// 广告计划出价方式
export const adPricing = {
  NONE: 0,
  CPM: 1,
  CPC: 2,
  CPT: 3,
  NOC: 4,
  FREE: 5,
  GD: 6,
  OCPC: 7,
  CPA: 7, // 实际上是OCPC，将错就错
  CPSD: 8, // CPA出价方式， SD的意思是start download
  OCPM: 9,
  CPV: 10,
};

export const scheduleType = {
  CONTINOUSLY: 1,
  DATE_RANGE: 2,
};

export const appRetargetingType = {
  NONE: 0,
  CUSTOM_AUDIENCE: 4,
  NEW_CUSTOM_AUDIENCE: 9,
  INCLUDE_SPECIFIC_EVENTS: 5,
  EXCLUDE_SPECIFIC_EVENTS: 6,
  INCLUDE_INTERACTE_USERS: 7,
  EXCLUDE_INTERACTE_USERS: 8,
};

/** app retargeting 人群包选项类型 */
export const AppRetargetingAudiencePackageType = {
  CUSTOMER_FILE: 0,
  APP_ACTIVITY: 3,
  PARTNER: 9,
};

// RF购买类型
export const rfBuyingType = {
  fixedBudget: 0, // 固定预算
  fixedImpression: 1, // 固定展示量
  fixedReachPercent: 2, // 固定Reach百分比
  fixedReach: 3, // 固定Reach量
};

// 出价方式(带文本)
export const bidType = [
  {
    text: '按点击(CPC)',
    value: 2,
  },
  {
    text: '按千次展示(CPM)',
    value: 1,
  },
];
// 落地页出价方式(带文本)
export const bidTypeExternal = [
  {
    text: '按点击(CPC)',
    value: 2,
  },
  {
    text: '按千次展示(CPM)',
    value: 1,
  },
  {
    text: '按转化(CPA)',
    value: 8,
  },
];
// 广告计划预算最低预算
export const minBudget = {
  CPC: 100,
  CPM: 100,
  CPSD: 300,
  OCPC: 300,
};
// OCPC
export const ocpc = {
  PHONE: 1,
  FORM: 2,
  MAP_SEARCH: 3,
  DOWNLOAD_FINISH: 4,
  INSTALL_FINISH: 15,
};
// OCPC转化目标
export const actionStatus = {
  UN_ACTIVE: 1,
  ACTIVE: 0,
};
// OCPC出价阶段
export const ocpcPhase = {
  PHASE_FIRST: 1,
  PHASE_SECOND: 2,
};
// 投放速度
// TODO: AB Test @xupeixiang
export const flowmode1 = [
  {
    text: '加速投放',
    value: 0,
  },
  {
    text: '标准投放(推荐)',
    value: 1,
  },
];
export const flowmode2 = [
  {
    text: '标准投放(推荐)',
    value: 1,
  },
  {
    text: '加速投放',
    value: 0,
  },
];
export const ocpcSkip = [
  {
    text: '是',
    value: 1,
  },
  {
    text: '否',
    value: 0,
  },
];
// 广告计划状态选项，广告计划按状态筛选时发送英文字段名（历史原因）
export const adStatus = {
  NONE: '',
  NO_DELETE: 'no_delete',
  DELIVERY_OK: 'delivery_ok',
  NOT_DELIVERY: 'not_delivery',
  PARTIAL_DELIVERLY_OK: 'some_delivery_ok',
  TIME_NO_REACH: 'time_no_reach',
  TIME_DONE: 'time_done',
  NO_SCHEDULE: 'no_schedule',
  DELETE: 'delete',
  DISABLE: 'disable',
  CAMPAIGN_DISABLE: 'campaign_disable',
  CAMPAIGN_OFFLINE_BUDGET: 'campaign_offline_budget',
  AUDIT: 'audit',
  REAUDIT: 'reaudit',
  OFFLINE_AUDIT: 'offline_audit',
  AD_OFFLINE_BUDGET: 'ad_offline_budget',
  OFFLINE_BUDGET: 'offline_budget',
  OFFLINE_BALANCE: 'offline_balance',
  PRE_ONLINE: 'pre_online',
  CREATE: 'create',
  AD_DISABLE: 'ad_disable',
  AUDIT_STATUS_ERROR: 'audit_status_error',
  CLOSED: 'rf_closed', // rf的广告状态
  // 资产上下线状态
  AD_ASSET_AUTHORIZATION_LOST: 'ad_asset_authorization_lost',
};

// dashboard 广告组状态
export const adGroupStatus = {
  ACTIVE: 1,
  REJECTED: 2,
  OUT_BUDGET: 3,
  DIAGNOSIS: 4,
};

// 品牌广告的投放状态选项，为不影响adStatus所以另写
export const brandStatus = {
  FROZEN: 'frozen',
  PRE_OFFLINE_BUDGET: 'pre_offline_budget',
  DRAFT: 'draft',
};

export const adStatusValues = {
  NONE: '',
  NO_DELETE: 'no_delete', // 后端实际不用该值，@TODO: remove
  DELIVERY_OK: 0,
  PARTIAL_DELIVERLY_OK: 63,
  TIME_NO_REACH: 11,
  TIME_DONE: 12,
  NO_SCHEDULE: 13,
  DELETE: 4,
  DISABLE: 5,
  CAMPAIGN_DISABLE: 6,
  CAMPAIGN_OFFLINE_BUDGET: 7,
  AUDIT: 2,
  REAUDIT: 3,
  OFFLINE_AUDIT: 41,
  AD_OFFLINE_BUDGET: 42,
  OFFLINE_BUDGET: 42,
  OFFLINE_BALANCE: 43,
  PRE_ONLINE: 45,
  CREATE: 21,
  AD_DISABLE: 61,
  PARTIAL_AUDIT: 62, // 部分国家审核完成，部分还在review
  AD_AUDIT_FAIL: 94,
  AUDIT_STATUS_ERROR: 101,
};

// 品牌广告的投放状态值，为不影响adStatusValue所以另写
export const brandStatusValues = {
  FROZEN: 51,
  PRE_OFFLINE_BUDGET: 44,
  DRAFT: 9,
};

// TODO:
// 转化的批量操作数字和其他表格的还不一样，需要考虑什么时候和后端协调统一一下
export const convertBatchingOperation = {
  NONE: -1,
  START: 0,
  PAUSE: 2,
  DELETE: 1,
};
export const convertStatusFilter = {
  ALL: -1,
  START: 0,
  DELETE: 1,
  PAUSE: 2,
};
// openurl对应权限
export const openurlRight = {
  // 审核&媒介
  AUDIT_AND_MEDIA: 1,
  // PM&RD
  PM_AND_RD: 2,
  // 普通广告主
  ADVERTISER: 3,
  // 白名单广告主
  WHITE_LIST: 4,
};
// 创建/编辑广告标识
export const createReviseOperation = {
  CREATE_FROM_CAMPAIGN: 0,
  CREATE_FROM_AD: 1,
  CREATE_FROM_CREATIVE: 2,
  REVISE_CAMPAIGN: 3,
  REVISE_FROM_AD: 4,
  REVISE_CREATIVE: 5,
};
// 广告类别
export const EnumAdClassify = [
  {
    key: 'adgroup_type_pruchase',
    value: 1,
  },
  {
    key: 'adgroup_type_trade',
    value: 2,
  },
  {
    key: 'adgroup_type_complimentary',
    value: 4,
  },
  {
    key: 'adgroup_type_promotion',
    value: 5,
  },
  {
    key: 'adgroup_type_make_good',
    value: 7,
  },
];
export const adgroupIos14Switch = {
  unset: 0, // 存量数据，含义和ios14-一样
  ios14Below: 1, // ios14-
  ios14Above: 2, // ios14+
  all: 3, // 所有流量，目前仅用于RF广告
};
export const ios14Threshold = 39;
export const nonDcOsvThreshold = 44;
// 是否占用quota
export const IOS14QuotaType = {
  UNOCCUPIED: 1,
  OCCUPIED: 2,
};
// 垂直游戏OCPC ROI调价
export const roiType = {
  NO: 0,
  YES: 1,
  // ocpc进入第二阶段
  TWO: 2,
};

export const platform = {
  ANDROID: 1,
  IOS: 2,
  PC: 16,
  ALL: 0,
};

export const platformToAppType = {
  [platform.ANDROID]: adAppType.ANDROID,
  [platform.IOS]: adAppType.IOS,
  [platform.ALL]: adAppType.NO_LIMIT,
  [platform.PC]: adAppType.NO_LIMIT,
};

export const AppStatusValue = {
  // app的状态
  // 100, 101, 200 表示app允许投放ios14
  // 300, 400, 401 表示app不允许投放ios14
  Permitted: 100,
  OwnershipVerifiedViaTTAppID: 101,
  Whitelisted: 200,
  Probated: 300,
  BlockedConflictAppAccount: 400,
  BlockedUnsupportedMMP: 401,
};
export const AppStatusObject = {
  Permitted: {
    value: AppStatusValue.Permitted,
    hint: 'adgroup_app_permitted_hint',
    type: 'info',
  },
  OwnershipVerifiedViaTTAppID: {
    value: AppStatusValue.OwnershipVerifiedViaTTAppID,
    hint: '',
  },
  Whitelisted: {
    value: AppStatusValue.Whitelisted,
    hint: '',
  },
  Probated: {
    value: AppStatusValue.Probated,
    hint: 'adgroup_app_probated_hint',
    type: 'error',
  },
  BlockedConflictAppAccount: {
    value: AppStatusValue.BlockedConflictAppAccount,
    hint: 'adgroup_app_conflict_account_hint',
    type: 'error',
  },
  BlockedUnsupportedMMP: {
    value: AppStatusValue.BlockedUnsupportedMMP,
    hint: 'adgroup_app_unsupport_mmp_hint',
    type: 'error',
  },
};
// 平台选择类型
export const platformTypes = [
  {
    text: 'iOS',
    value: 2,
  },
  {
    text: 'Android',
    value: 1,
  },
  {
    text: 'PC',
    value: 16,
  },
];
// 转化目标类型
export const transformTargets = [
  {
    text: '转化',
    value: 11,
  },
  {
    text: '有效播放',
    value: 22,
  },
  {
    text: '点击',
    value: 2,
  },
  {
    text: '展示',
    value: 1,
  },
];

// DPA广告类型
export const dpaAdtype = {
  EXTERNAL: 0,
  DOWNLOAD: 1,
};

// cpt下i18nad信息流的推广目的
export const CptEnumPromotionPurposeI18nad = {
  EXTERNAL: '102',
  DOWNLOAD: '6',
};

// cpt下ies信息流 -》 强原生时的推广目的
export const CptEnumPromotionPurposeIesNative = {
  PURE_SHOW: '301',
  EXTERNAL: '301',
  DOWNLOAD: '303',
};

// cpt下ies信息流 -》 强导流时的推广目的
export const CptEnumPromotionPurposeIesGuide = {
  EXTERNAL: '1',
  DOWNLOAD: '6',
};

// 出价阶段
export const EnumBiddingPhase = {
  first: 1,
  second: 2,
};

/* eslint-disable quote-props */
// 国际化 Android 可定向版本从Android  4.0 开始（4.0 以下DAU用户少于10个），
// 到9.0 为止（新增8.1 / 9.0），与站内相比缺4.5 版本（貌似这个版本不是很官方？DAU < 10），
// 顺序排列
export const ANDROID_OSV_OPTIONS = {
  '4.0': 8,
  '4.1': 9,
  '4.2': 10,
  '4.3': 11,
  '4.4': 12,
  // '4.5': 13,
  '5.0': 14,
  '5.1': 15,
  '6.0': 16,
  '7.0': 17,
  '7.1': 18,
  '8.0': 19,
  '8.1': 20,
  '9.0': 21,
  '10.0': 22,
};

// ios系统版本枚举,国际化 iOS 可定向版本从iOS 8.0 开始 (8.0 以下没有用户)，
// 到12.1 为止（新增11.4 / 12.0 / 12.1）
// 顺序排列
export const IOS_OSV_OPTIONS = {
  '8.0': 10,
  '8.1': 11,
  '8.2': 12,
  '9.0': 15,
  '9.1': 16,
  '9.2': 17,
  '9.3': 18,
  '10.1': 19,
  '10.2': 20,
  '10.3': 21,
  '11.0': 22,
  '11.1': 23,
  '11.2': 24,
  '11.3': 25,
  '11.4': 26,
  '12.0': 27,
  '12.1': 28,
  '12.2': 29,
  '12.3': 30,
  '12.4': 31,
  '13.0': 32,
  '13.1': 33,
  '13.2': 34,
  '13.3': 35,
  '13.4': 36,
  '13.5': 37,
};

// 批量出价方式
export const bidModeNumber = {
  range: 1,
  percent: 2,
  money: 3,
};

export const bidModeOptions = [
  {
    value: 1,
    key: 'range',
    label: '幅度',
  },
  {
    value: 2,
    key: 'percent',
    label: '百分比',
  },
  {
    value: 3,
    key: 'money',
    label: '金额',
  },
];

export const smartBidTypes = {
  standard: 0,
  maxConvertion: 3, // maxcv bid 后面会下掉
  maxConvertionNoBid: 7, // no bid 与 maxcv nobid 的 smart bid type 值都是 7
};
// adgroup 的售卖类型
export const buyType = [
  {
    value: 1,
    labelKey: 'adgroup_purchase',
  },
  {
    value: 2,
    labelKey: 'adgroup_trade',
  },
  {
    value: 4,
    labelKey: 'adgroup_complimentary',
  },
  {
    value: 5,
    labelKey: 'adgroup_promotion',
  },
  {
    value: 7,
    labelKey: 'adgroup_make_good',
  },
];

// 深度转化出价方式
export const DEEP_BID_TYPE = {
  NONE: 0,
  MIN: 1,
  PACING: 2,
  IAEO: 101,
  VO_COST_CAP: 7,
  VO_MINIMUN_ROAS: 108,
  VO_HIGHEST_VALUE: 109,
};
export const batchVersion = {
  latest: 0, // 最新版本
  canUpdate: 1, // 可升级版本
  offline: 2, // 下线版本
  skipVersion: 3, // 废弃版本
  willUpdata: 4, // 普通用户预上线版本
};

export const bulkCreateAdsStatus = {
  creating: 0, // 创建中
  someError: 1, // 部分创建成功
  createFail: 2, // 完全创建失败
  createSuccess: 3, // 全部创建成功
};
// 三方监测链接类型

export const TrackType = {
  CLICK: 1,
  IMPRESSION: 2,
  OTHERS: 3,
  VIDEO_VIEWABILITY: 100, // 视频可见性检测
};

// 行为定向的时长范围框选
export const BEHAVIOR_DAYS = {
  NONE: {
    id: 0,
    label: 0,
  },
  IN_7_DAY: {
    id: 7,
    label: 7,
  },
  IN_15_DAY: {
    id: 15,
    label: 15,
  },
};
// 拒审内容类型
export const auditRejectContentType = {
  contentString: 1,
  contentImg: 2,
  contentVideo: 3,
};
export const operationTypes = {
  // 批量二期的操作类型
  importAds: 1,
  downloadTemplate: 2,
  exportAdSet: 3,
  exportAppList: 4,
  exportPixelList: 5,
  exportAudienceList: 6,
};

// 人群包类型
export const AUDIENCE_TYPE = {
  RETARGET: {
    i18n: 'module_dpa_ad_retarget',
    value: 1,
    hint: 'module_dpa_ad_retarget_hint',
    disableHint: 'module_dpa_ad_retarget_disabled_hint',
  },
  NORMAL: {
    i18n: 'module_adgroup_find_prospective_customers',
    value: 0,
    hint: 'module_adgroup_find_prospective_customers_hint',
    disableHint: 'module_adgroup_find_prospective_customers_disabled_hint',
  },
};

// 行为兴趣的 Video Action
export const VIDEO_ACTIONS = [
  { label: 'Finish', i18nKey: 'module_adgroup_behavior_video_action_finish', value: 0 },
  { label: 'Like', i18nKey: 'module_adgroup_behavior_video_action_like', value: 1 },
  { label: 'Comment', i18nKey: 'module_adgroup_behavior_video_action_comment', value: 2 },
  { label: 'Share', i18nKey: 'module_adgroup_behavior_video_action_share', value: 3 },
];
// 视频来源
export const VIDEO_BUSINESS = {
  QUICK_OPTIMIZATION_TOOLS: 38, // 一键优化工具
  VIDEO_EDITOR_TOOLS: 18, // 视频编辑器
  AD_SITE: 1, // ad后台本地上传
  PICTURE_TO_VIDEO: 6, // 模板视频
  OPEN_API: 8, // OpenAPI
  MICRO_MOVIE: 23, // 微电影
  SHOPIFY: 46, // Shopify
  FAST_CREATION: 47, // 移动创意工具 for tt4b mobile
  QUICK_OPTIMIZATION_LITE: 50, // Precheck QuickFix
  VIDEO_AUTO_SCALE: 53, // 尺寸自适应
  SMART_SOUND_TRACK: 54, // 智能配乐
  SMB_DIAGNOSIS_TOOLS: 70, // smb一键优化
  TT4B_DIAGNOSIS_TOOLS: 57, // TT4B一键优化
};

export const MATERIAL_TYPE = {
  IMAGE: 2,
  VIDEO: 3,
};
// DPA视频展示模式
export const DPA_VIDEO_DISPLAY_MODE_TYPE = {
  AUTO: 1,
  CUSTOM: 2,
};

// DPA 重定向事件日期选择列表
export const DPA_RETARGET_DAY_LIST = [1, 2, 3, 7, 14, 30, 60, 90, 180];

export const DEEP_EXTERNAL_ACTION = {
  ACTIVE_REGISTER: 13, // 激活且注册
  ACTIVE_PAY: 14, // 激活且付费
  NEXT_DAY_OPEN: 39, // 激活且次留
  LTV_ROI: 110, // ROI
  GAME_ADDICTION: 25, // 关键行为
  CUSTOMER_EFFECT: 26, // 有效获客
  SOCIAL_ROI: 27, // 社交ROI
  FIRST_DAY_ROI: 160, // 首日roi
  UG_ROI: 178, // 内广ROI
  CLUE_CONFIRM: 194, // 线索-回访信息确认
  CLUE_INTERFLOW: 195, // 线索-回访加为好友
  CLUE_HIGH_INTENTION: 196, // 线索-回访高潜成交
  CLUE_PAY_SUCCEED: 218, // 线索-支付存在意向
  PREMIUM_ROI: 232, // 保险ROI
};

export const CREATOR_FOLLOWING_ACTIONS = [
  { label: 'Following', i18nKey: 'adgroup_target_interest_add_following_behaviors_following', value: 4 },
  { label: 'View Homepage', i18nKey: 'adgroup_target_interest_add_following_behaviors_homepage', value: 5 },
];

export const BEHAVIOR_TARGETING_SCENES_TYPE = {
  video: 2,
  creator: 11,
  hashtag: 13,
};

export const TargetingKeywordsScene = {
  INTEREST_CATEGORIES: 10,
  INTEREST_KEYWORDS: 12,
  BEHAVIOR_HASHTAG: 13,
};

export const TargetingKeywordsSearchMode = {
  FUZZY: 1,
  SEMANTIC: 2,
};

export const TargetingKeywordsSearchStatus = {
  ONLINE: 1,
  OFFLINE: 2,
  PRE_OFFLINE: 3,
  LEGAL_OFFLINE: 4,
};

export const TargetingKeywordsType = {
  INTEREST_CATEGORIES: 1,
  INTEREST_KEYWORDS: 2,
  HASHTAG: 3,
  HASHTAG_GROUP: 4,
};

/**
 * 创意类型对应到计划层级的标志
 */
export const STYLE_TYPE = {
  DEFAULT: 0,
  STORE_FRONT: 11,
};

// 批量报错信息枚举
export const BULK_ERROR_TYPE = {
  ERROR: 0,
  WARNING: 1,
};
// 批量账号状态报错枚举
export const BULK_ACCOUNT_ERROR_TYPE = {
  QUALIFICATION: 2, // 没有补全资质
  PAYMENT: 3, // 没有选payment方式
  ALL: 4, // 上述两种情况都有
};
/**
 * 诊断建议reason_type对应枚举值
 */
export const REASON_TYPE = {
  NORMAL: 100,
  LOW_BID: 101,
  LOW_RESOLUTION: 201, // 分辨率过低
  INSUFFICIENT_LENGTH: 202, // 长度短
  NO_BACKGROUND_MUSIC: 203, // 无音乐
  LOADING_PAGE_TIME: 204, // 落地页加载时间过长
  PIXEL_NO_RECENT_ACTION: 301, // Pixel无近期活动
};

/**
 * 检查对应平台Target url是否存在的枚举值
 */
export const EXPECT_TARGETURL_FIELD = {
  IOS: 'landingUrl.targetUrlIosApp',
  ANDROID: 'landingUrl.targetUrlAndroidApp',
};

/**
 * 是否期望Target url存在的枚举值
 */
export const ISEXPECT_TARGETURL = {
  YES: 0,
  NO: 1,
};
// adgroup suggestion sideslip枚举
export const adgroupSuggestionType = {
  none: -1,
  audit: 0,
  diagnosis: 1,
};

export const AutoTargetingEnum = {
  AUTO: 1, // 自动定向
  MANUAL: 0, // 手动定向
};
// dpa重定向的受众选项
export const DPA_RETARGET_OPTIONS = [
  {
    label: 'module_dpa_ad_custom_viewed',
    value: 4002,
  },
  {
    label: 'module_dpa_ad_custom_added',
    value: 4003,
  },
  {
    label: 'module_dpa_ad_custom_purchased',
    value: 4006,
  },
];

// url跳转枚举
export const URL_ACTION_TYPE = {
  DIAGNOSIS: 1,
  OPENEDIT: 2,
  OPEN_SUGGESTION: 3,
};

export const MaterialStatusMap = {
  1: {
    nameI18nKey: 'data_creative_status_exploring',
    hoverI18nKey: 'data_creative_status_exploring_hover',
  },
  2: {
    nameI18nKey: 'data_creative_status_running',
    hoverI18nKey: 'data_creative_status_running_hover',
  },
  3: {
    nameI18nKey: 'data_creative_status_limited',
    hoverI18nKey: 'data_creative_status_limited_hover',
  },
  4: {
    nameI18nKey: 'data_creative_status_inactive',
    hoverI18nKey: '',
  },
};

// Rnf 库存位置枚举
export const FEED_POSITION_ENUM = {
  STANDARD: false,
  PREMIUM: true,
};

export const FEED_POSITION_OPTIONS = [
  {
    i18n_key: 'module_adgroup_standard_feed_title',
    desc: 'module_adgroup_standard_feed_desc',
    id: FEED_POSITION_ENUM.STANDARD,
  },
  {
    i18n_key: 'module_adgroup_top_feed_title',
    desc: 'module_adgroup_top_feed_desc',
    id: FEED_POSITION_ENUM.PREMIUM,
  },
];

// 可见性产品枚举
export const ViewabilityVerificationType = {
  MOAT: 1,
  DV: 2,
  IAS: 3,
};

export const VOStatus = {
  QUALIFIED: 1,
  NOEVENT: 2,
  NOVALUE: 3,
  INSUFFICIENT_EVENTS: 4,
  NOTSUPPORT: 200,
};

export const voStatusAppOptions = () => ({
  [VOStatus.INSUFFICIENT_EVENTS]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_insufficient_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_app_event_insufficient_desc', { eventNum: 30, dayNum: 7 }),
  },
  [VOStatus.NOEVENT]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_app_waiting_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_app_waiting_desc'),
  },
  [VOStatus.NOVALUE]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_value_require_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_app_event_value_require_desc'),
  },
  [VOStatus.QUALIFIED]: {
    showPopover: false,
    disabled: false,
    hoverTitle: '',
    hoverContext: '',
  },
  [VOStatus.NOTSUPPORT]: {
    showPopover: false,
    disabled: false,
    hoverTitle: '',
    hoverContext: '',
  },
});

export const voStatusWebsiteOptions = () => ({
  [VOStatus.INSUFFICIENT_EVENTS]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_insufficient_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_website_event_insufficient_desc', { eventNum: 20, dayNum: 7 }),
  },
  [VOStatus.NOEVENT]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_website_no_event_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_website_no_event_desc'),
  },
  [VOStatus.NOVALUE]: {
    showPopover: true,
    disabled: true,
    hoverTitle: i18n.t('module_adgroup_bidding_vo_event_value_require_title'),
    hoverContext: i18n.t('module_adgroup_bidding_vo_website_event_value_require_desc'),
  },
  [VOStatus.QUALIFIED]: {
    showPopover: false,
    disabled: false,
    hoverTitle: '',
    hoverContext: '',
  },
  [VOStatus.NOTSUPPORT]: {
    showPopover: false,
    disabled: false,
    hoverTitle: '',
    hoverContext: '',
  },
});

export const TargetingExpansionType = {
  AGE: 1,
  GENDER: 2,
  INTEREST_BEHAVIOR: 3,
  AUDIENCE: 4,
};

// 品牌安全产品枚举
export const BrandSafetyTrackTypeMap = {
  UNSET: 0,
  ZEFR: 1,
  IAS: 2,
  DV: 3,
};

// campagin creative列表页query_list按需请求投前指标 132+2
const adv_metrics = [
  'adv_region_type',
];
const campaign_metrics = [
  'ab_test',
  'campaign_name',
  'campaign_budget',
  'campaign_budget_mode',
  'campaign_status',
  'campaign_primary_status',
  'objective_type',
  'campaign_opt_status',
  'campaign_isdel',
  'landing_type',
  'campaign_db_status',
  'budget_optimize_switch',
  'campaign_struct_version',
  'campaign_create_time',
  'campaign_dedicate_type',
  'po_number',
  'campaign_deep_bid_type',
  'campaign_roas_bid',
];
const ad_metrics = [
  'ad_name',
  'ad_rating_tags',
  'ad_reasons',
  'ad_ref_app_id',
  'ad_audit_status',
  'ad_audit_result_type',
  'ad_status',
  'ad_db_status',
  'bid',
  'bid_objective',
  'ad_budget',
  'ad_budget_mode',
  'ad_create_time',
  'ad_is_previewable',
  'ad_ref_app_id',
  'ad_ref_pixel_id',
  'app_type',
  'country_code',
  'audit_rating_type',
  'ad_can_copy',
  'ad_last_audit_time',
  'ad_opt_status',
  'ad_primary_status',
  'bid_smart',
  'cpa_bid',
  'content_type',
  'country_ids',
  'cpa_bid_objective',
  'cpa_skip_first_phrase',
  'cpa_phrase',
  'cpv_video_duration_type',
  'creative_material_mode',
  'deep_bid_objective',
  'deep_convert_cnt_note',
  'deep_convert_cost_note',
  'deep_convert_cvr_note',
  'deep_cpa_bid',
  'deep_external_action',
  'external_action',
  'effect_cost_note',
  'effect_note',
  'effect_rate_note',
  'end_time',
  'start_time',
  'inventory_flow',
  'inventory_flow_type',
  'has_affected_creative',
  'action_days',
  'inventory_status',
  'objective_type',
  'optimize_goal',
  'pricing',
  'product_platform_id',
  'product_set_id',
  'schedule_type',
  'schedule',
  'smart_bid_type',
  'convert_id',
  'ad_inventory_status',
  'campaign_id',
  'ad_struct_version',
  'external_type',
  'aeo_type',
  'external_url',
  'scheduled_budget_timestamp',
  'scheduled_budget',
  'ad_is_drop',
  'ad_suggestion_type',
  'diagnosis_status',
  'learn_phase_status',
  'diagnosis_detail',
  'diagnosis_time',
  'flow_control_mode',
  'roas_bid',
  'search_delivery_type',
  'promotion_website_type',
  'ab_test_status',
];
const creative_metrics = [
  'creative_title',
  'creative_name',
  'creative_status',
  'creative_primary_status',
  'creative_opt_status',
  'creative_audit_result_type',
  'call_to_action',
  'creative_db_status',
  'creative_rating_tags',
  'creative_is_previewable',
  // 'creative_last_audit_time',
  'language_list',
  'image_info',
  'image_mode',
  'video_info',
  'campaign_id',
  'creative_is_viewable',
  'ad_id',
  'creative_inventory_status',
  'item_source',
  // 'creative_reasons',
  'creative_type',
  'page_id',
  'call_to_action_id',
  'creative_item_source',
  'inventory_status_types',
  'creative_struct_version',
  'creative_create_time',
  'creative_external_url',
  'creative_avatar_icon',
  'creative_app_name',
  'identity_type',
  'identity_id',
  'creative_explore_status',
  'identity_bc_id',
  'page_id_status',
//  'video_info_source',
//  'video_info_download_allowed',
];

export const RequiredTargets = [
  ...adv_metrics,
  ...campaign_metrics,
  ...ad_metrics,
  ...creative_metrics,
];
export const checkIsRealLive = creativeType => CREATIVE_TYPE.SHOP_LIVE_REAL_TIME === creativeType;
// 广告类型
const ADS_TYPE = {
  search: '3', // 搜索广告类型是'3'
};
// 使用此方法判断是否属于搜索广告
export const checkIsSearch = searchDeliveryType => searchDeliveryType === ADS_TYPE.search;
// 搜索广告一期campaign允许披露的类型枚举
export const campaignPermitSearchEnum = [1, 2, 3, 4, 5, 8];

// age定向选项
export const targetAgeOptions = [
  { value: '18,24', label: '18-24' },
  { value: '25,34', label: '25-34' },
  { value: '35,44', label: '35-44' },
  { value: '45,54', label: '45-54' },
  { value: '55,100', label: '55+' },
];
export const HHIType = {
  TOP5: 1,
  TOP10: 2,
  TOP10_25: 3,
  TOP25_50: 4,
};
export const HHIList = [
  {
    label: i18n.t('module_adgroup_target_hhi_item_label', { num: '10%' }),
    id: HHIType.TOP10,
  },
  {
    label: i18n.t('module_adgroup_target_hhi_item_label', { num: '10%-25%' }),
    id: HHIType.TOP10_25,
  },
  {
    label: i18n.t('module_adgroup_target_hhi_item_label', { num: '25%-50%' }),
    id: HHIType.TOP25_50,
  },
  {
    label: i18n.t('module_adgroup_target_hhi_item_label', { num: '5%' }),
    id: HHIType.TOP5,
  },
];
